import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useSEO, generateWebPageSchema } from '../../utils/seo';

const AccessPage = () => {
  // SEO設定
  useSEO({
    title: '京都山科 アクセス・交通案内 | 大石神社',
    description: '大石神社へのアクセス方法のご案内。京阪電車・JR・地下鉄「山科駅」から徒歩約15分。名神高速道路京都東ICより約10分。無料駐車場完備（約30台）。住所：〒607-8308 京都府京都市山科区西野山桜ノ馬場町116。電話：075-581-5645',
    keywords: 'アクセス,交通案内,地図,駐車場,山科駅,京都東IC,行き方,所在地,住所,電話番号,大石神社,京都,山科',
    canonical: '/access',
    schema: generateWebPageSchema('アクセス・交通案内', '大石神社へのアクセス方法。電車・お車でのアクセス、駐車場情報', '/access')
  });

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navbar />
      
      <div className="pt-32 pb-24">
        <div className="max-w-6xl mx-auto px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-20"
          >
            <h1 className="text-[#D4AF37] font-serif text-6xl font-bold mb-6 tracking-wide">アクセス</h1>
            <div className="w-24 h-[1px] bg-[#D4AF37] mx-auto mb-8"></div>
            <p className="text-white text-lg leading-relaxed">
              大石神社へのアクセス方法をご案内いたします。
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-[#1A1A1A] border border-[#D4AF37]/30 rounded-lg overflow-hidden mb-12"
          >
            <div className="w-full h-[500px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d5498.535334704212!2d135.79633899477116!3d34.97042474376985!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60010efb4befb261%3A0xbf291d328a8c0e09!2z5aSn55-z56We56S-!5e0!3m2!1sja!2sjp!4v1766550491613!5m2!1sja!2sjp"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-[#1A1A1A] border border-[#D4AF37]/30 rounded-lg p-10 mb-12"
          >
            <div className="flex items-start gap-4 mb-6">
              <i className="ri-map-pin-line text-[#D4AF37] text-3xl"></i>
              <div>
                <h2 className="text-white font-bold text-2xl mb-3 tracking-wide">所在地</h2>
                <p className="text-gray-300 text-lg">〒607-8308</p>
                <p className="text-gray-300 text-lg">京都府京都市山科区西野山桜ノ馬場町116</p>
              </div>
            </div>
          </motion.div>

          <div className="grid grid-cols-1 gap-8 mb-12">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="bg-[#1A1A1A] border border-[#D4AF37]/30 rounded-lg p-10"
            >
              <div className="flex items-start gap-4 mb-6">
                <i className="ri-train-line text-[#D4AF37] text-3xl"></i>
                <h2 className="text-white font-bold text-2xl tracking-wide">電車でお越しの方</h2>
              </div>
              <div className="space-y-4 text-gray-300 ml-12">
                
                <div className="border-l-2 border-[#D4AF37] pl-6 py-2">
                  <p className="font-semibold text-white mb-2">地下鉄</p>
                  <p>地下鉄東西線「椥辻駅」下車 徒歩約15分</p>
                </div>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="bg-[#1A1A1A] border border-[#D4AF37]/30 rounded-lg p-10"
            >
              <div className="flex items-start gap-4 mb-6">
                <i className="ri-train-line text-[#D4AF37] text-3xl"></i>
                <h2 className="text-white font-bold text-2xl tracking-wide">バスでお越しの方</h2>
              </div>
              <div className="space-y-4 text-gray-300 ml-12">
                
                <div className="border-l-2 border-[#D4AF37] pl-6 py-2">
                  <p className="font-semibold text-white mb-2">京阪バス</p>
                  <p>「大石神社前」下車 徒歩約3分　(京都駅より約15分)</p>
                </div>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="bg-[#1A1A1A] border border-[#D4AF37]/30 rounded-lg p-10"
            >
              <div className="flex items-start gap-4 mb-6">
                <i className="ri-car-line text-[#D4AF37] text-3xl"></i>
                <h2 className="text-white font-bold text-2xl tracking-wide">お車でお越しの方</h2>
              </div>
              <div className="space-y-4 text-gray-300 ml-12">
                <div className="border-l-2 border-[#D4AF37] pl-6 py-2">
                  <p className="font-semibold text-white mb-2">名神高速道路</p>
                  <p>京都東ICより約10分</p>
                  <p>京都南ICより約15分</p>
                </div>
                 <div className="border-l-2 border-[#D4AF37] pl-6 py-2">
                  <p className="font-semibold text-white mb-2">第2京阪道路</p>
                  <p>山科ICより約1分</p>
                </div>
                <div className="border-l-2 border-[#D4AF37] pl-6 py-2">
                  <p className="font-semibold text-white mb-2">駐車場</p>
                  <p>無料駐車場完備（約20台）</p>
                  <p className="text-sm text-gray-400 mt-1">※義士祭など大きな行事の際は満車になる場合がございます</p>
                </div>
              </div>
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-[#1A1A1A] border border-[#D4AF37]/30 rounded-lg p-10"
          >
            <div className="flex items-start gap-4 mb-6">
              <i className="ri-phone-line text-[#D4AF37] text-3xl"></i>
              <h2 className="text-white font-bold text-2xl tracking-wide">お問い合わせ</h2>
            </div>
            <div className="space-y-3 text-gray-300 ml-12">
              <div className="flex items-center gap-3">
                <i className="ri-phone-fill text-[#D4AF37]"></i>
                <p>TEL: 075-581-5645</p>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-time-line text-[#D4AF37]"></i>
                <p>受付時間: 9:00〜16:00</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AccessPage;
